const updateRawSrc = mainImage => rawSrc => mainImage.dataset.rawSrc = rawSrc ? rawSrc : mainImage.dataset.rawSrc;

export default updateRawSrc